import { memo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BackButton from '../../components/BackButton';
import SuccessButton from '../../components/SuccessButton';

const ConfirmDialog = ({ open, onClose, onSuccess, statusLoading }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: '#131313',
        },
      }}>
      <DialogContent>
        Are you sure to change the statuses of selected apps?
      </DialogContent>
      <DialogActions>
        <BackButton onClick={onClose}>No</BackButton>
        <SuccessButton onClick={onSuccess} disabled={statusLoading}>
          Yes
        </SuccessButton>
      </DialogActions>
    </Dialog>
  );
};

export default memo(ConfirmDialog);
